import { memo } from "react";
function NextStopCompliancePickupMarker({ stopSequence, textColor, color }) {
  const shiftLeft = stopSequence && stopSequence < 10 ? 0 : -3;
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 23 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="1.5"
        y="1"
        width={29 - 3}
        height={29 - 2}
        rx="1.5"
        fill={color}
        stroke={textColor}
        strokeWidth={1}
      />
      <text
        id={8}
        fontFamily="OpenSans-SemiBold, Open Sans"
        fontSize={10}
        fontWeight={500}
        fill={textColor}
      >
        <tspan x={9 + shiftLeft} y={16}>
          {stopSequence}
        </tspan>
      </text>
    </svg>
  );
}

export default memo(NextStopCompliancePickupMarker);
